'use client'

import { qrUriAtom } from 'features/generator/generatorState'
import { useHydrateAtoms } from 'jotai/utils'

import {
	socialMediaContentAtom,
	TSocialMediaContent,
} from '../SocialMediaContentState'
import { SocialMediaScreen } from './SocialMediaScreen'

export const SocialMediaLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TSocialMediaContent
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[socialMediaContentAtom, content],
	])

	return <SocialMediaScreen previewMode={false} demoMode={false} />
}
